export enum WorkspaceStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}
